import { useAtomValue } from 'jotai';

import { meRolesNamesAtom } from '../atom';

export const useMeRoleNames = () => {
  const roleNames = useAtomValue(meRolesNamesAtom);

  return {
    roleNames,
  };
};
